<script>
    export let mebot_img_url = '';
</script>

<center>
    <br><br>
<span style="display: flex; align-items:center; text-align: center; justify-content: center;">
<span class="info">You have <b>0 steps left!</b><br> Recharge your Mebot by going for a walk 🏃‍♂️ taking more steps.<br>
    <center>
    <table><tr><td align=center valign=middle>
    <span style="display: flex; align-items:center; text-align: center; justify-content: center;"><img src={mebot_img_url} width="28px" alt="Your mebot"/> 
    <span class="text-electric-yellow">⚡</span> 👟 </span>
    </td></tr></table>
    </center>
    <br>
</span>
</span>
</center>

<style>
.info {
    text-shadow: 0 0 5px rgba(255, 254, 249, 0.4),
    0 0 8px rgba(251, 251, 251, 0.3);
    font-family: arial;
    color: hsl(60, 29%, 97%);
    font-size: 18px;
}

.text-electric-yellow {
    text-shadow: 0 0 5px rgba(255, 229, 61, 0.9),
    0 0 8px rgba(255, 239, 65, 0.98);
    font-family: arial;
    color: hsl(61, 97%, 75%);
}
</style>
